import script from "./addImaging.vue?vue&type=script&setup=true&lang=ts"
export * from "./addImaging.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__